<template>
  <div class="home">
    <UpperBanner />
  </div>
</template>

<script>
import UpperBanner from "@/components/home_page/UpperBanner.vue"; // Import your components

export default {
  name: "HomeView",
  data() {
    return {
      // Example of fake reviews
    };
  },
  components: {
    UpperBanner,
  },
};
</script>
<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");

.titl {
  font-family: "Noto Kufi Arabic", sans-serif;
}
.reviews-section {
  margin-top: 20px;
}
.hel {
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 935px) {
  .hel {
    display: flex;
    justify-content: center;
  }
}
</style>
